<template>
    <rkm-modal
        :loading="loading"
        hide-footer
        ref="RkmModal"
        title="Selecione o local"
    >
        <Form
            :fila="fila"
            :salas="salas"
            :tela="tela"
            @stored="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        fila: null,
        tela: null,
    }),
    methods: {
        open(fila, tela) {
            this.fila = fila
            this.tela = tela
            this.$refs.RkmModal.show()
        },
        handleExit() {
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        salas: { type: Array, required: true },
    },
}
</script>